//@ts-check
import React, { useState, useEffect } from "react"
import StepHeader from "./step-header"
import ParameterInput from "./parameter-input"
import ValueOrChoose from "./value-or-choose"
import store from "../store";
import StyleWrapper from "src/utils/stylesWrapper"
import { useStepIndex } from "./step-index-context";

export default function FundEtherStep() {
  var stepIndex=useStepIndex()
  return (
    <StyleWrapper>
      <StepHeader />
      <div>
        <div css="
          margin-top: 20px">
          <ValueOrChoose
            label="to"
            hint="where to send funds"
            type="address"
            optional
            value={store.steps[stepIndex].to}
            onChange={v => {
              console.log('here')
              store.steps[stepIndex].to = v
              store.updateStore()
            }}
          />
        </div>
        <div css="
          margin-top: 20px">
          <ParameterInput
            label="amount"
            hint="funds in Ether"
            type="ether"
            value={store.steps[stepIndex].gwei}
            onChange={v => {
              store.steps[stepIndex].gwei = v.target.value
              store.updateStore()
            }}
          />
        </div>
      </div>
    </StyleWrapper>
  )
}
